import { c as _c } from "react/compiler-runtime";
import { ChainUtils } from '@morpho-org/blue-sdk';
import { Avatar } from '@morpho-org/ui-v6/client';
import { memo } from 'react';
import type { VaultV2Caps } from '../../types/pendingTimelocks';
import { HoverableWrapper } from '../VaultV2PendingTimelockStyled';
export type CollateralToken = Extract<VaultV2Caps[number]['data'], {
  __typename: 'CollateralCapData';
}>['collateralToken'];
interface CollateralTokenLinkProps {
  collateralToken: NonNullable<CollateralToken>;
}
const CollateralTokenLink = t0 => {
  const $ = _c(13);
  const {
    collateralToken
  } = t0;
  let t1;
  if ($[0] !== collateralToken.address || $[1] !== collateralToken.chain.id) {
    t1 = e => {
      e.stopPropagation();
      const url = ChainUtils.getExplorerAddressUrl(collateralToken.chain.id, collateralToken.address);
      window.open(url, "_blank");
    };
    $[0] = collateralToken.address;
    $[1] = collateralToken.chain.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== collateralToken.logoURI) {
    t2 = <Avatar src={collateralToken.logoURI} size="small" />;
    $[3] = collateralToken.logoURI;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== collateralToken.symbol) {
    t3 = <span className="text-2xs text-foreground">{collateralToken.symbol}</span>;
    $[5] = collateralToken.symbol;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="gap-2xs flex items-center">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <HoverableWrapper onClick={t1}>{t4}</HoverableWrapper>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default memo(CollateralTokenLink);